import { NgModule } from '@angular/core'
import { OrderStatusComponent } from './order-status.component'
import { CommonModule } from '@angular/common'
import { MaterialModule } from '../../shared/material.module'

@NgModule({
  declarations: [OrderStatusComponent],
  imports: [CommonModule, MaterialModule],
  providers: [],
  exports: [OrderStatusComponent]
})
export class OrderStatusModule {}
